import { __assign, __makeTemplateObject, __rest } from "tslib";
import { css, px } from '../../../../foundation';
import { RcIconButtonSizes } from '../../../Buttons/IconButton/utils';
import { checkedStyles } from '../../utils';
import { RadioButtonIconClasses, RcRadioClasses } from '../utils';
export var RadioStyle = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    // * for overwrite Mui fontSize in default Radio
    // * 1.2 for mui icon have some apace in radio
    var currSize = RcIconButtonSizes[size];
    var fontSize = px(currSize * 1.2);
    // * 0.2 / 2 for both direction
    var disSize = px(currSize * 0.1);
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n\n    .", " {\n      svg {\n        font-size: ", ";\n        margin: -", ";\n      }\n    }\n  "], ["\n    ", ";\n\n    .", " {\n      svg {\n        font-size: ", ";\n        margin: -", ";\n      }\n    }\n  "])), checkedStyles(__assign(__assign({ size: size }, rest), { classes: RcRadioClasses })), RadioButtonIconClasses.root, fontSize, disSize);
};
var templateObject_1;
